module.exports = __webpack_public_path__ + "img/6-1_02.01b9b7ab.jpg";